import {EFormStep} from './definitions';

export default {
  signInButton: 'Войти',
  signInHint: 'Уже зарегистрированы?',
  formStepsInfo: {
    [EFormStep.COUNTRY]: {
      title: 'Где зарегистрирована ваша компания?',
      hint: 'Выберите страну, в которой зарегистрировано ваше юридическое лицо',
    },
    [EFormStep.NAME]: {
      title: 'Как вас зовут?',
    },
    [EFormStep.PHONE]: {
      title: 'Телефон',
      hint: 'Номер для связи и подтверждения',
    },
    [EFormStep.EMAIL]: {
      title: 'Email',
      hint: 'На этот email отправим ссылку для подтверждения',
    },
  },
  formStepsTitle: {
    [EFormStep.COUNTRY]: 'Страна',
    [EFormStep.NAME]: 'Пользователь',
    [EFormStep.PHONE]: 'Телефон',
    [EFormStep.EMAIL]: 'Email',
  },
  form: {
    countryLabel: 'Выберите страну',
    countryHint:
      'Если вашей страны нет в списке, для регистрации перейдите по ссылке <0>{{link}}</0>',
    nameLabel: 'Ваше имя',
    emailLabel: 'Ваш email',
    captchaLabel: 'Введите код с картинки',
    agreementCondition: 'Я <0>соглашаюсь</0> с <1>политикой обработки персональных данных</1>',
    advertisementCondition:
      'Я соглашаюсь на получение рекламных сообщений edna, новостей компании, интересных кейсов и трендах рынка',
    termsAndConditions:
      '<0>Нажимая кнопку, вы принимаете условия</0><br/>' + '<1>Пользовательского соглашения</1>',
    emailExistError:
      'Пользователь с таким email уже существует. Измените email или войдите в существующий личный кабинет',
  },
  success: {
    title: 'Проверьте ваш email',
    hint:
      'Перейдите по ссылке из письма, которое мы отправили на вашу почту, и все готово!\n' +
      '<0>Ссылка действительна 24 часа</0>',
    managerSupport: 'Наш менеджер свяжется с вами',
  },
  error: {
    title: 'Что-то пошло не так',
    hint:
      'При регистрации произошла непредвиденная ошибка\n\n' +
      'Пожалуйста, попробуйте еще раз позже',
  },
  mobile: {
    formStepsInfo: {
      [EFormStep.PHONE]: {title: 'Номер для связи и подтверждения'},
      [EFormStep.EMAIL]: {title: 'E-mail'},
    },
    form: {
      captchaLabel: 'Введите цифры с картинки',
      advertisementCondition: 'Соглашаюсь на получение рекламных сообщений edna',
      emailExistError: 'Пользователь с таким email уже существует. Измените email или войдите',
    },
    error: {
      hint:
        'Нам очень жаль, при регистрации произошла непредвиденная ошибка\n\n' +
        'Попробуйте еще раз позже',
    },
  },
};
